enum CommerceImageTypes {
  logo = 1,
  banner = 2,
}

export default CommerceImageTypes;
